import { HttpClient, HttpErrorResponse, HttpHandler } from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { catchError, Observable, throwError } from 'rxjs'
import { ERROR_LOGGING_PAGES } from './error-logging.config'
import { ErrorSenderService } from './error-sender.service'
import { environment } from '@env/environment'

@Injectable()
export class TrackedHttpClient extends HttpClient {
  private _errorSenderService: ErrorSenderService | null = null

  constructor(
    handler: HttpHandler,
    private injector: Injector
  ) {
    super(handler)
  }

  private get errorSenderService(): ErrorSenderService {
    if (!this._errorSenderService) {
      this._errorSenderService = this.injector.get(ErrorSenderService)
    }
    return this._errorSenderService
  }

  override request(first: any, url?: any, options?: any): Observable<any> {
    const requestStack = new Error().stack
    const method = typeof first === 'string' ? first.toUpperCase() : first?.method || 'UNKNOWN'

    return super.request(first, url, options).pipe(
      catchError((error) => {
        ;(error as any).__requestStack = requestStack

        const isActivePage = ERROR_LOGGING_PAGES.some((p) => window.location.pathname.includes(p))

        if (
          error instanceof HttpErrorResponse &&
          error.status < 500 &&
          error.status !== 0 &&
          error.status !== 401 &&
          !error.url?.includes('/app_errors/') &&
          (environment.environment !== 'prod' || isActivePage)
        ) {
          this.errorSenderService.sendError({
            title: `HTTP ${error.status}: ${method} ${error.url}`,
            error_class: 'HttpError',
            level: 'error',
            error_message: error.message,
            error_callstack: requestStack,
            http: {
              status: error.status,
              method,
              url: error.url || '',
              response_body:
                typeof error.error === 'string'
                  ? error.error.substring(0, 1000)
                  : JSON.stringify(error.error)?.substring(0, 1000),
            },
          })
        }

        return throwError(() => error)
      })
    )
  }
}
